import {
    Button,
    Container,
    CssBaseline,
    makeStyles,
    TextField,
    Typography,
    Input,
    InputAdornment,
    InputLabel,
    IconButton,
    FormControl,
    Grid,
    List,
    ListItem,
    Box,
} from '@material-ui/core';
import { COLORS } from '../Theme';

import React, { Fragment, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { SIcon } from '../Icon';

import { useCookies } from 'react-cookie';
import { useSnackbar } from 'notistack';
import ToastStr from '../../request/toastStr';

import axios from 'axios';
import {
    admin as v_admin,
    basic,
    Values,
    SNACKBAR_TIME,
} from '../../request/values';
import { Class, DoubleArrow } from '@material-ui/icons';

//const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
    nanumSquare_regular: {
        fontFamily: 'NanumR',
    },
    background: {
        width: '100vw',
        height: '100vh',
        background: `url("/images/background.png")`,
    },
    content: {
        width: '100%',
        height: '100%',
        display: 'grid',
    },
    mainPage: {
        display: 'grid',
        gridTemplateRows: '1.5fr 5fr',
    },
    title: {
        margin: '5vh 0px 0px 35px',
        fontFamily: 'NanumR',
        fontSize: '1.5rem',
        fontWeight: 'bold',
        display: 'flex',
        gap: '10vw',
    },
    logo: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'stretch',
        //border: 'solid white',
        margin: '5vh 0px',
        borderWidth: '0px 0px 1px 0px',
        //cursor: 'pointer',
        '& img': {
            width: '30px',
            maxHeight: '50%',
            height: '30px',
            margin: '12px 5px 0px 9%',
        },
        '& #name': {
            display: 'inline-block',
            margin: '10px 0px 0px 0px',
            width: 'calc(91% - 35px)',
            fontFamily: 'NanumR',
            fontSize: '1.5rem',
            fontWeight: 'bolder',
        },
        '& #welcome': {
            display: 'block',
            margin: '5px 0px 0px 9%',
            fontFamily: 'NanumR',
            fontSize: '1.2rem',
        },
    },
    userinfo: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        border: 'none',
        borderWidth: '0px 0px 1px 0px',
        paddingBottom: '0.5vh',
        '& #name': {
            display: 'inline-block',
            fontFamily: 'NanumR',
            fontSize: '1.25rem',
            fontWeight: 'bolder',
        },
    },
    menu: {
        display: 'grid',
        border: 'none',
        borderWidth: '0px 0px 1px 0px',
        fontFamily: 'NanumR',
        fontSize: '1.5rem',
        fontWeight: 'bold',
        '&::after': {
            content: '""',
            position: 'absolute',
            width: '0',
            height: '0',
            left: '50%',
            bottom: '0',
            borderBottom: '3px solid black',
            transition: 'width 0.3s ease, left 0.3s ease',
            WebkitTransition: 'width 0.3s ease, left 0.3s ease',
        },
        '&:hover::after': {
            width: '100%',
            left: '0',
        },
        '&:hover': {
            backgroundColor: 'transparent', // hover 배경색 제거
        },
    },
    navigator: {
        display: 'grid',
        gridTemplateColumns: '1fr 2fr',
        marginTop: '1%',
        //fontSize: '5vw',
        //backgroundColor: `${COLORS.WHITE}`,
    },
    subTitle: {
        minWidth: '10vw',
        display: 'flex',
        flexDirection: 'column',
    },
    menuOpen: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
        marginTop: '10px',
        gap: '10px',
        '& a': {
            margin: '5px',
            fontSize: '1rem',
            width: 'fit-content',
            height: '100%',
            cursor: 'pointer',
            textAlign: 'center',
            position: 'relative',
            '&::after': {
                content: '""',
                position: 'absolute',
                display: 'inline-block',
                width: '0',
                height: '0',
                left: '50%',
                bottom: '-5px',
                borderBottom: '2px solid black',
                transition: 'width 0.3s ease, left 0.3s ease',
                WebkitTransition: 'width 0.3s ease, left 0.3s ease',
            },
            '&:hover::after': {
                width: '100%',
                left: '0',
            },
        },
    },
    menuClose: {
        display: 'none',
    },

    classList: {
        display: 'flex',
        //alignItems: 'center',
        marginTop: '5vh',
        justifyContent: 'center',
    },
    modifyClass: {
        maxHeight: '50px',
        padding: '5px 25px',
        magin: '7px 7px',
        width: '100%',
        height: '60%',
        color: `${COLORS.WHITE}`,
        borderRadius: '10px',
        backgroundColor: `${COLORS.PUMPKIN}`,
        '&:hover': {
            color: `${COLORS.PUMPKIN}`,
        },
    },
    table: {
        display: 'grid',
        gridTemplateRows: '0.7fr 5fr 0.7fr',
        width: '40vw',
        height: '45vh',
        margin: '1% auto',
        border: 'none',
        borderRadius: '10px',
        backgroundColor: `${COLORS.WHITE}`,
        '& #downInfo': {
            border: 'none',
        },
    },
    tableTitle: {
        display: 'flex',
        alignItems: 'center',
        width: '40vw',
        padding: '5px 15px',
        border: 'solid lightgray',
        borderWidth: '0 0 1px 0',
    },
    titleName: {
        fontSize: 'inherit',
        fontWeight: 'bold',
        color: `${COLORS.SLATE_GREY}`,
    },
    tableInfo: {
        display: 'grid',
        gridTemplateRows: '20px 1fr 1fr 1fr 10px',
        //border: 'solid lightgray',
        //borderWidth: '0 0 2px 0',
        '& #interests': {
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: '0 15px',
        },
        '& input': {
            width: '100%',
            paddingLeft: '7px',
            outline: 'none',
            maxHeight: '50px',
        },
        '& select': {
            maxHeight: '50px',
            padding: '5px',
            fontFamily: 'Nanumgothic',
            appearance: 'none',
        },
        '& #codeContainer': {
            display: 'grid',
            gridTemplateColumns: '1fr 150px',
            '& button': {
                borderRadius: '10px',
                margin: '0 auto',
                color: `${COLORS.WHITE}`,
                backgroundColor: `${COLORS.PUMPKIN}`,
            },
            '& #classCode': {
                margin: '0 15px 0 0',
            },
        },
    },
    infoContainer: {
        padding: '5px 30px',
        display: 'grid',
        gridTemplateRows: '30px 1fr',
    },
    buttonContainer: {
        display: 'grid',
        gridTemplateColumns: '2.5fr 1fr',
        padding: '0 30px',
    },
    classInfo: {
        display: 'grid',
        gridTemplateColumns: '3fr 4fr 8fr 3fr',
        padding: '25px 0',
        backgroundColor: `${COLORS.LIGHT_GREY}`,
    },
    selectBox: {
        maxHeight: '50px',
        position: 'relative',
        width: '100%',
        height: '100%',
        appearance: 'textfield',
    },
    select: {
        width: 'inherit',
        height: 'inherit',
        background: 'transparent',
        border: '0 none',
        outline: '0 none',
        padding: '0 5px',
        position: 'relative',
        zIndex: 3,
    },
    arrowIcon: {
        position: 'absolute',
        // backgroundColor: `${COLORS.WATER_BLUE}`,
        top: '0',
        right: '0',
        zIndex: 1,
        width: '40px',
        height: 'inherit',
        borderLeft: '1px solid black',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& img': {
            width: '50%',
        },
    },
    buttonLabel: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: `${COLORS.CHARCHOAL_GREY}`,
        fontSize: 18,
        fontFamily: 'NanumB',
        fontWeight: 'bold',
        lineHeight: '21px',
    },
}));

const SERVER = basic.server;

type iClassList = {
    class_code: string;
    init_stock: number;
    max_loan: number;
    interest: number;
    interest_time: number;
    interest_hms: string;
};

const SubadminModifyClass: React.FC<any> = (props) => {
    const classes = useStyles();

    const { member } = props;

    const history = useHistory();
    const state: any = history.location.state;
    const classCode = state.code;
    const className = state.name;
    const info = state.ClassList;

    const [initStock, setInitStock] = useState<any | null>();
    const [maxLoan, setMaxLoan] = useState<any | null>();
    const [interest, setInterest] = useState<any | null>();
    const [interestTime, setInterestTime] = useState<any | null>();
    const [interestHms, setInterestHms] = useState<any | null>();
    const [auth, setAuth] = useState<boolean>(false);
    const [menu, setMenu] = useState<boolean>(false);
    const [operMenu, setOperMenu] = useState<boolean>(false);

    const [cookies, setCookie, removeCookie] = useCookies();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = e.target;
        if (id == 'initStock') setInitStock(value);
        else if (id == 'maxLoan') setMaxLoan(value);
        else if (id == 'interest') setInterest(value);
        else if (id == 'interestTime') setInterestTime(value);
        else if (id == 'interestHms') setInterestHms(value);
    };

    const valueChangeHandler2 = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = e.target;
        setInterestHms(value);
    };

    const searchClass = () => {
        let url = new URL(SERVER + v_admin.admin + v_admin.search_class);
        let params = {
            id: member.id.toString(),
            targetClassName: className.toString(),
        };
        url.search = new URLSearchParams(params).toString();
        axios({
            method: 'GET',
            withCredentials: true,
            //url: SERVER + v_admin.admin + v_admin.search_class,
            url: url.toString(),
            headers: {
                'Access-Control-Allow-Origin': basic.server_url,
                mode: 'cors',
                'Access-Control-Allow-Headers':
                    'Origin, X-Requested-With, Content-Type, Accept',
            },
        })
            .then((res) => {
                return res.data;
            })
            .then((data: any) => {
                console.log('data?', data);
                if (data.code == Values.SUCCESS_CODE) {
                    document
                        .getElementById('initStock')
                        ?.setAttribute('value', data.data[0].init_stock);
                    setInitStock(data.data[0].init_stock);
                    document
                        .getElementById('maxLoan')
                        ?.setAttribute('value', data.data[0].max_loan);
                    setMaxLoan(data.data[0].max_loan);
                    document
                        .getElementById('interest')
                        ?.setAttribute('value', data.data[0].interest);
                    setInterest(data.data[0].interest);
                    document
                        .getElementById('interestTime')
                        ?.setAttribute('value', data.data[0].interest_time);
                    setInterestTime(data.data[0].interest_time);

                    switch (data.data[0].interest_hms) {
                        case 'H':
                            document
                                .getElementById('h')
                                ?.setAttribute('selected', 'selected');
                            break;
                        case 'M':
                            document
                                .getElementById('m')
                                ?.setAttribute('selected', 'selected');
                            break;
                        case 'S':
                            document
                                .getElementById('s')
                                ?.setAttribute('selected', 'selected');
                            break;
                    }
                    setInterestHms(data.data[0].interest_hms);
                }
            });
    };

    const classModify = (event: any) => {
        if (
            isNaN(initStock) ||
            isNaN(maxLoan) ||
            isNaN(interest) ||
            isNaN(interestTime)
        )
            enqueueSnackbar(ToastStr.CHECK_MONEY_INFO_STR, {
                variant: 'warning',
                autoHideDuration: SNACKBAR_TIME,
            });
        else {
            axios({
                method: 'POST',
                data: {
                    classCode: classCode,
                    initStock: initStock,
                    maxLoan: maxLoan,
                    interest: interest,
                    interestTime: interestTime,
                    interestHms: interestHms,
                },
                withCredentials: true,
                url: SERVER + v_admin.admin + v_admin.update_class,
            })
                .then((res) => {
                    return res.data;
                })
                .then((data: any) => {
                    console.log(data);
                    if (data.code == Values.SUCCESS_CODE) {
                        history.push({
                            pathname: '/subAdminClassManage',
                        });
                    } else {
                        if (data.code == Values.FAIL_CODE) {
                            enqueueSnackbar(ToastStr.CLASS_CREATE_FAIL_STR, {
                                variant: 'warning',
                                autoHideDuration: SNACKBAR_TIME,
                            });
                        } else {
                            enqueueSnackbar(
                                ToastStr.REQUEST_GET_POST_FAIL_STR,
                                {
                                    variant: 'error',
                                    autoHideDuration: SNACKBAR_TIME,
                                }
                            );
                        }
                    }
                });
        }
    };

    const moveClassList = () => {
        history.push('/subAdminClassList');
    };
    const moveClassManage = () => {
        history.push('/subAdminClassManage');
    };
    const moveOperList = () => {
        history.push('/subAdminOperList');
    };

    useEffect(() => {
        searchClass();
    }, []);
    return (
        <div className={classes.background}>
            <CssBaseline />
            <div className={classes.content}>
                <div className={classes.mainPage}>
                    <div className={classes.navigator}>
                        <div className={classes.logo}>
                            <img src="/images/p.webp"></img>
                            <Typography id="name">플레이스타트업</Typography>
                            <Typography id="welcome">
                                {member.name}님, 환영합니다!
                            </Typography>
                        </div>
                        <div className={classes.title}>
                            <div
                                className={classes.subTitle}
                                onMouseOver={() => {
                                    setMenu(true);
                                }}
                                onMouseOut={() => {
                                    setMenu(false);
                                }}
                            >
                                <Button
                                    className={classes.menu}
                                    onClick={() => moveClassList()}
                                >
                                    교육
                                </Button>
                                <div
                                    className={
                                        menu
                                            ? classes.menuOpen
                                            : classes.menuClose
                                    }
                                >
                                    <a onClick={(e) => moveClassList()}>
                                        교육 목록
                                    </a>
                                    <a onClick={(e) => moveClassManage()}>
                                        교육 관리 목록
                                    </a>
                                </div>
                            </div>
                            <div
                                className={classes.subTitle}
                                onMouseOver={() => {
                                    setOperMenu(true);
                                }}
                                onMouseOut={() => {
                                    setOperMenu(false);
                                }}
                            >
                                <Button
                                    className={classes.menu}
                                    onClick={() => moveOperList()}
                                >
                                    강사
                                </Button>
                                <div
                                    className={
                                        operMenu
                                            ? classes.menuOpen
                                            : classes.menuClose
                                    }
                                >
                                    <a onClick={(e) => moveOperList()}>
                                        강사 관리
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classes.classList}>
                        <div className={classes.table}>
                            <div className={classes.tableTitle}>
                                <Typography className={classes.titleName}>
                                    자금 정보 입력
                                </Typography>
                            </div>
                            <div className={classes.tableInfo} id="downInfo">
                                <div></div>
                                <div className={classes.infoContainer}>
                                    <script>console.log(ClassList);</script>
                                    <Typography>기업 초기 자본금</Typography>
                                    <input
                                        type="text"
                                        id="initStock"
                                        onChange={valueChangeHandler}
                                    ></input>
                                </div>
                                <div className={classes.infoContainer}>
                                    <Typography>최대 대출 금액</Typography>
                                    <input
                                        type="text"
                                        id="maxLoan"
                                        onChange={valueChangeHandler}
                                    ></input>
                                </div>
                                <div
                                    className={classes.infoContainer}
                                    id="interests"
                                >
                                    <Typography>이자율</Typography>
                                    <Typography>이자 주기</Typography>
                                    <Typography>단위 설정(시,분,초)</Typography>
                                    <input
                                        type="text"
                                        id="interest"
                                        onChange={valueChangeHandler}
                                    ></input>
                                    <input
                                        type="text"
                                        id="interestTime"
                                        onChange={valueChangeHandler}
                                    ></input>
                                    <div className={classes.selectBox}>
                                        <select
                                            className={classes.select}
                                            id="interestHMS"
                                            onChange={valueChangeHandler2}
                                        >
                                            <option value="selected"></option>
                                            <option id="h" value="H">
                                                시
                                            </option>
                                            <option id="m" value="M">
                                                분
                                            </option>
                                            <option id="s" value="S">
                                                초
                                            </option>
                                        </select>
                                        <span className={classes.arrowIcon}>
                                            <img src="/images/down_blue.webp" />
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.buttonContainer}>
                                <div></div>
                                <Button
                                    className={classes.modifyClass}
                                    onClick={classModify}
                                >
                                    <Typography>수정하기</Typography>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubadminModifyClass;
